<script>
import _ from 'lodash'

export default {
  inheritAttrs: false,
  props: {
    birthDay: {
      type: [Number, null],
      default: null,
    },
    birthMonth: {
      type: [Number, null],
      default: null,
    },
    editMode: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    error: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modelBirthDay: this.birthDay,
      modelBirthMonth: this.birthMonth,
    }
  },
  computed: {
    formattedValue() {
      if (this.formatter) {
        return this.formatter(this.value)
      }
      return this.value
    },
    isRequired() {
      return this.rules.includes('required')
    },
    getMonthDays() {
      if (this.modelBirthMonth === 2) {
        return _.range(1, 29 + 1)
      }

      if ([4, 6, 9, 11].includes(this.modelBirthMonth)) {
        return _.range(1, 30 + 1)
      }

      return _.range(1, 31 + 1)
    },
    formattedBirthday() {
      if (this.modelBirthMonth && this.modelBirthDay) {
        return `${_.padStart(this.modelBirthMonth, 2, '0')}/${_.padStart(this.modelBirthDay, 2, '0')}`
      }

      return 'N/A'
    },
  },
  watch: {
    birthDay: {
      handler: function (newVal) {
        this.modelBirthDay = newVal
      },
    },
    birthMonth: {
      handler: function (newVal) {
        this.modelBirthMonth = newVal
        this.makeDateCorrectForMonth()
      },
    },
  },
  methods: {
    onInput(inputEvent, name) {
      let value = inputEvent
      if (inputEvent instanceof Event) {
        value = parseInt(inputEvent.target?.value) || null
      }
      if (name === 'birthDay') {
        this.$emit('update:birthDay', value)
      }

      if (name === 'birthMonth') {
        this.$emit('update:birthMonth', value)
      }
    },
    makeDateCorrectForMonth() {
      if (!this.modelBirthDay) {
        return
      }

      if (!this.getMonthDays.includes(this.modelBirthDay)) {
        this.$emit('update:birthDay', null)
      }
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.labelContainer">
      <div>
        <p :class="$style.label" class="p1">Birthday</p>
      </div>
    </div>
    <div :class="$style.birthdayContainer">
      <template v-if="!editMode">
        <h4 :class="$style.value">{{ formattedBirthday || 'N/A' }}</h4>
      </template>
      <template v-if="editMode">
        <ValidationProvider
          v-slot="{ changed, errors }"
          :rules="modelBirthDay ? 'required' : ''"
          :debounce="1000"
          immediate
          :name="'Month'">
          <BaseSelect
            v-model="modelBirthMonth"
            :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            :disabled="disabled"
            :empty-text="'Month'"
            :changed="changed"
            @change="onInput($event, 'birthMonth')"></BaseSelect>
          <p v-if="errors[0]" :class="$style.errorMessage" class="tag-text">{{ errors[0] }}</p>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ changed, errors }"
          :rules="modelBirthMonth ? 'required' : ''"
          :debounce="1000"
          immediate
          :name="'Day'">
          <BaseSelect
            v-model="modelBirthDay"
            :options="getMonthDays"
            :disabled="disabled"
            :empty-text="'Day'"
            :changed="changed"
            @change="onInput($event, 'birthDay')"></BaseSelect>

          <p v-if="errors[0]" :class="$style.errorMessage" class="tag-text">{{ errors[0] }}</p>
        </ValidationProvider>
      </template>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  overflow-y: initial;

  div[class*='errorContainer'] {
    position: relative;
  }
}

.birthdayContainer {
  display: flex;

  div:first-child {
    margin-right: 10px;
  }
}

.labelContainer {
  position: relative;
  display: flex;
  align-items: center;

  div[data-tooltip-icon] {
    position: initial;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
}

.label {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $dark-gray;
}

.value {
  font-weight: 700;
  color: $primary-blue;
  overflow-wrap: break-word;
}

.errorMessage {
  @extend %error-message;

  text-align: center;
}
</style>
